export default "/assets/images/technology-graph-04.45c8af10df275d3c.svg";